import { getEnvs } from "state/EnvironmentsContext/EnvContext";

export const CLOUDINARY_CLOUD_NAME =
  getEnvs((state) => state.cloudinary_cloud_name) || "swtchcc";

export const CLOUDINARY_UPLOAD_PRESET =
  getEnvs((state) => state.cloudinary_upload_preset) || "uacvjtnm";

export const CLOUDINARY_IMAGE_UPLOAD_PRESET =
  getEnvs((state) => state.cloudinary_image_upload_preset) || "uacvjtnm";

export const CLOUDINARY_VIDEO_UPLOAD_PRESET =
  getEnvs((state) => state.cloudinary_video_upload_preset) || "uacvjtnm";

/**
 * Gets the Cloudinary configuration (type and upload preset) based on the file's mime type.
 * @param {File|string|null} file The file object or base64 string.
 * @param {string} fallbackPreset The fallback upload preset if not image or video.
 * @param {string} defaultType The default resource type (image, video, raw, auto).
 * @returns {{ type: string, uploadPreset: string, cloudName: string, uploadUrl: string }}
 */
export const getCloudinaryConfig = (
  file,
  fallbackPreset = getEnvs((s) => s.cloudinary_upload_preset) || "uacvjtnm",
  defaultType = "auto",
) => {
  const isBase64 = typeof file === "string" && file.startsWith("data:");
  const mimeType = isBase64 ? file.split(";")[0].split(":")[1] : file?.type;

  const isImageType = mimeType?.startsWith("image/");
  const isVideoType = mimeType?.startsWith("video/");

  let type = defaultType;
  let uploadPreset = fallbackPreset;

  if (isImageType) {
    type = "image";

    uploadPreset =
      getEnvs((s) => s.cloudinary_image_upload_preset) || fallbackPreset;
  } else if (isVideoType) {
    type = "video";

    uploadPreset =
      getEnvs((s) => s.cloudinary_video_upload_preset) || fallbackPreset;
  }

  const cloudName = getEnvs((s) => s.cloudinary_cloud_name) || "swtchcc";

  const uploadUrl = `https://api.cloudinary.com/v1_1/${cloudName}/${type}/upload`;

  return { type, uploadPreset, cloudName, uploadUrl };
};
